class DefaultScaffolderFormDecoratorsApi {
  constructor(options) {
    this.options = options;
  }
  static create(options) {
    return new DefaultScaffolderFormDecoratorsApi(
      options ?? { decorators: [] }
    );
  }
  async getFormDecorators() {
    return this.options.decorators;
  }
}

export { DefaultScaffolderFormDecoratorsApi };
//# sourceMappingURL=FormDecoratorsApi.esm.js.map
